import React from "react";
import { Modal, IconButton } from "@mui/material";
import TextView from "components/TextView";
import Button from "components/Button";
import CloseIcon from "@mui/icons-material/Close";
import {
  ModalContainerSuccess,
  ModalContentSuccess,
  TopIcon,
  IconWrapper,
} from "./Success.styled";

function AiBuilderSuccessModal({ isOpen, onClose, onSuccess }) {
  const handleClose = () => {
    onClose();
    onSuccess();
  };

  return (
    <div>
      <Modal open={isOpen} onClose={handleClose}>
        <ModalContainerSuccess>
          <IconButton
            edge="start"
            color="inherit"
            size="large"
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
          <ModalContentSuccess>
            <TopIcon />
            <TextView
              variant="title"
              style={{
                textAlign: "center",
                marginBottom: "20px",
                fontSize: "20px",
              }}
            >
              Feel free to keep creating and exploring <br /> while AI creates
              your Wheel!
            </TextView>
            <div>
              <Button
                onClick={handleClose}
                style={{
                  padding: "10px 20px",
                  fontSize: "14px",
                  display: "inline-block",
                  textAlign: "center",
                  borderRadius: "5px",
                }}
              >
                Can't wait!
              </Button>
            </div>
          </ModalContentSuccess>
        </ModalContainerSuccess>
      </Modal>
    </div>
  );
}

export default AiBuilderSuccessModal;
